import React from "react";
import {SectionAccessVehicleTabTableApp} from "../Funtiomallity/SectionAccessVehicleTabTableApp";
import CustomTable from "../../../../components/table/CustomTable";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SectionAccessVehicleTab =({
    setBodyForExport,
    setCriteria,
    finalArray,
    modified,
    setModified
}) => {

    const {
        tableId,
        searchId,
        thead,
        tbody,
        pagination
    } = SectionAccessVehicleTabTableApp({
        setBodyForExport,
        setCriteria,
        finalArray,
        modified,
        setModified
    })

    return (
        <>
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={false}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
            />
            {pagination()}
        </>
    )
}

export default SectionAccessVehicleTab
